import React, { useEffect, useState } from "react";
import { Handle, Position } from "reactflow";
import api from "../../api/client";

export default function StageNode({ data, isConnectable, selected }) {
  const {
    name,
    color = "#6366f1",
    maxConcurrentAssignees = 1,
    isReassignable = false,
    estimatedDuration = 0,
    durationUnit = "Days",
    tasks = [],
    sendForReview = false,
    assigneeRoles = [],
    branchMode = "CHOICE",
    outgoingCount = 0,
  } = data || {};

  const showBranchBadge = outgoingCount >= 2;
  const isParallel = branchMode === "PARALLEL";

  const [roleNames, setRoleNames] = useState([]);

  useEffect(() => {
    if (assigneeRoles && assigneeRoles.length > 0) {
      api
        .get("/roles")
        .then((r) => {
          const map = {};
          r.data.forEach((role) => {
            map[role.id] = role.name;
          });
          setRoleNames(assigneeRoles.map((id) => map[id]).filter(Boolean));
        })
        .catch((e) => console.error("failed to load roles", e));
    } else {
      setRoleNames([]);
    }
  }, [assigneeRoles]);

  return (
    <div
      style={{
        width: 240,
        borderRadius: 10,
        boxShadow: selected
          ? "0 0 0 3px rgba(99,102,241,0.2)"
          : "0 6px 16px rgba(15,23,42,0.08)",
        overflow: "hidden",
        background: "#ffffff",
        border: "1px solid #e5e7eb",
      }}
    >
      <div
        style={{
          background: color,
          color: "#fff",
          padding: "8px 10px",
          fontWeight: 700,
          fontSize: 13,
          letterSpacing: 0.2,
          position: "relative",
        }}
      >
        {name}
        {showBranchBadge && (
          <div
            title={
              isParallel
                ? "Parallel — all branches start together"
                : "Choice — reviewer picks one branch"
            }
            style={{
              position: "absolute",
              top: 5,
              right: 6,
              width: 20,
              height: 20,
              borderRadius: 6,
              background: "rgba(255,255,255,0.92)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 1px 3px rgba(15,23,42,0.25)",
            }}
          >
            {isParallel ? (
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0f766e"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="3" y1="7" x2="18" y2="7" />
                <polyline points="14 3 18 7 14 11" />
                <line x1="3" y1="17" x2="18" y2="17" />
                <polyline points="14 13 18 17 14 21" />
              </svg>
            ) : (
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#b45309"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="6" y1="3" x2="6" y2="15" />
                <circle cx="18" cy="6" r="3" />
                <circle cx="6" cy="18" r="3" />
                <path d="M18 9a9 9 0 0 1-9 9" />
              </svg>
            )}
          </div>
        )}
      </div>
      <div
        style={{
          padding: 10,
          display: "grid",
          gap: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 12, color: "#111827" }}>
            <div style={{ fontWeight: 600 }}>
              {maxConcurrentAssignees} assignee
              {maxConcurrentAssignees > 1 ? "s" : ""}
            </div>
            {/* <div style={{ fontSize: 11, color: "#6b7280" }}>
              {isReassignable ? "Reassignable" : "No reassignment"}
            </div> */}
          </div>
          <div
            style={{
              fontSize: 12,
              background: "#f1f5f9",
              padding: "4px 8px",
              borderRadius: 999,
              fontWeight: 600,
              color: "#0f172a",
            }}
          >
            {estimatedDuration} {durationUnit}
          </div>
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {roleNames.length > 0 && (
            <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
              {roleNames.map((rn) => (
                <div
                  key={rn}
                  style={{
                    fontSize: 11,
                    padding: "2px 6px",
                    borderRadius: 999,
                    background: "#d1fae5",
                    color: "#065f46",
                    fontWeight: 600,
                  }}
                >
                  {rn}
                </div>
              ))}
            </div>
          )}
          <div
            style={{
              fontSize: 11,
              padding: "2px 6px",
              borderRadius: 999,
              background: "#e0f2fe",
              color: "#075985",
              fontWeight: 600,
            }}
          >
            {tasks.length} task{tasks.length === 1 ? "" : "s"}
          </div>
          {sendForReview && (
            <div
              style={{
                fontSize: 11,
                padding: "2px 6px",
                borderRadius: 999,
                background: "#fef3c7",
                color: "#92400e",
                fontWeight: 600,
              }}
            >
              Review
            </div>
          )}
        </div>
      </div>
      <Handle
        type="target"
        position={Position.Left}
        style={{ left: -8 }}
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ right: -8 }}
        isConnectable={isConnectable}
      />
    </div>
  );
}
